(function () {
    'use strict';

    angular.module('app')
        .factory('ContentFactory', ContentFactory);

    /* @ngInject */
    function ContentFactory($http, $rootScope) {

        var basePath = '/api/content';

        return {
			load: load,
			save: save
        };

        function load(key) {

            console.log('getting', key);

            var fullPath = basePath + '?key=' + key;

            return $http.get(fullPath, {cache: !$rootScope.allowEditingContent}).then(function success(response) {
                return response.data;
            }, function failure() {
                console.log('Failed to get data at', fullPath);
            });
        }

        function save(key, value) {

            console.log('saving', key);

            var fullPath = basePath + '?key=' + key;

            return $http.post(fullPath, {key: key, value: value}).then(function success(response) {
                return response.data;
            }, function failure() {
                console.log('Failed to save data at', fullPath);
            });
        }
    }
})();